import type { NxStatusMap } from '@soft2code/nexpo-lib/ui';

/**
 * As situações que o expositor vê: etapa do contato e situação do chamado.
 *
 * O contato segue a temperatura da conversa — novo pede ação, fechado é
 * resultado. O chamado segue quem precisa agir.
 */
export const EXHIBITOR_STATUS_MAP: NxStatusMap = {
	NEW: { label: { 'pt-BR': 'Novo', es: 'Nuevo', en: 'New' }, tone: 'info' },
	CONTACTED: { label: { 'pt-BR': 'Em conversa', es: 'En conversación', en: 'Talking' }, tone: 'accent' },
	QUALIFIED: { label: { 'pt-BR': 'Em conversa', es: 'En conversación', en: 'Talking' }, tone: 'accent' },
	PROPOSAL: { label: { 'pt-BR': 'Com proposta', es: 'Con propuesta', en: 'Proposal sent' }, tone: 'warning' },
	WON: { label: { 'pt-BR': 'Fechado', es: 'Cerrado', en: 'Closed' }, tone: 'success' },
	LOST: { label: { 'pt-BR': 'Não fechou', es: 'No se cerró', en: 'Not closed' }, tone: 'neutral' },

	OPEN: { label: { 'pt-BR': 'Novo', es: 'Nuevo', en: 'New' }, tone: 'info' },
	PROGRESS: { label: { 'pt-BR': 'Em andamento', es: 'En curso', en: 'In progress' }, tone: 'warning' },
	RESOLVED: { label: { 'pt-BR': 'Resolvido', es: 'Resuelto', en: 'Resolved' }, tone: 'success' },
	CLOSED: { label: { 'pt-BR': 'Fechado', es: 'Cerrado', en: 'Closed' }, tone: 'neutral' },
};
